/* eslint-disable indent */
import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";

import Starter from "../../../component/Starter";
import Card from "../../../component/card/Card";
import TableHeader from "../../../component/tableHeader/TableHeader";
import useSortableData from "../../../customHooks/sortingHooks";
import { tableHeaderData } from "./leaveData";
import { helperFunction } from "../../../constant/helper";
import TopInput from "./TopInput";
import { hrActions } from "../../../redux/actions";
import { types } from "../../../redux/type";
import LeaveList from "./LeaveList";
import axios from "axios";
import { api } from "../../../apis";

const initialState = {
  date: "",
  year: "",
  month: "",
  dataType: "",
  locationId: "",
  leaveFilter: ""
};

const AllLeave = () => {
  const dispatch = useDispatch();
  const loginType = localStorage.getItem("loginType");
  const [allLeave, setAllLeave] = useState([]);
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);
  // const [selectedCategory, setSelectedCategory] = useState([]);
  const { currentUser } = useSelector((state) => state.auth);

  const { hrResponse, hrError, hrLoading, leaveList } = useSelector(
    (state) => state.hr
  );

  const { locationError, locations } = useSelector(
    (state) => state.location
  );

  useEffect(() => {
    if (hrError) {
      helperFunction.toastHelper("error", hrError);
    }
    if (hrResponse) {
      helperFunction.toastHelper("success", hrResponse);
    }
  }, [hrError, hrResponse]);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
  }, [locationError]);

  useEffect(() => {
    setAllLeave(leaveList);
  }, [leaveList]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  const { items, requestSort, sortConfig } = useSortableData(
    allLeave
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value
    });
  };

  const onGetLeave = (e) => {
    e.preventDefault();
    if (values.locationId !== "") {
      const data = JSON.stringify(values);
      dispatch(hrActions.setHrLoading(true));
      dispatch(hrActions.clearHrErrors());
      dispatch(hrActions.clearHrResult());
      dispatch(hrActions.getALlLeaves(data, loginType));
    } else {
      const errorData = {
        data: { message: "Location Not selected" },
        status: 400
      };
      dispatch({
        type: types.HrTypes.HR_GET_ERRORS,
        payload: errorData
      });
    }
  };

  const changeSelectedStatus = async (e, leaveId) => {
    const { value } = e.target;

    try {
      const { baseUrlNode } = await helperFunction.checkLoginType(
        loginType
      );
      const leavePostData = {
        leaveId: leaveId,
        leaveStatus: value
      };
      const url = `${baseUrlNode}${api.Hr_Api.TAKE_LEAVE_ACTION_API}/${loginType}`;
      const response = await axios.post(url, leavePostData);

      const { data } = response;
      helperFunction.toastHelper("success", data.message);
    } catch (getRequestError) {
      helperFunction.toastHelper(
        "error",
        getRequestError.response.data.message
      );
    }

    setAllLeave(
      allLeave.map((clickUser) => {
        if (clickUser._id === leaveId) {
          clickUser.leaveStatus = value;
        }
        return clickUser;
      })
    );
  };

  return (
    <Starter
      topBarTitle="Leaves"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">HR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">HR</a>
          </li>
          <li className="breadcrumb-item active">Leaves</li>
        </Fragment>
      }
    >
      <Card>
        <TopInput
          values={values}
          hrLoading={hrLoading}
          onGetLeave={onGetLeave}
          currentUser={currentUser}
          allLocations={allLocations}
          onChange={handleInputChange}
        />

        <div className="table-responsive">
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>
                <TableHeader
                  tableHeaderData={tableHeaderData}
                  requestSort={requestSort}
                  sortConfig={sortConfig}
                />
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <LeaveList
                hrLoading={hrLoading}
                changeSelectedStatus={changeSelectedStatus}
                leaveListData={items}
              />
            </tbody>
          </table>
        </div>
      </Card>
    </Starter>
  );
};

export default AllLeave;
